export const Logo = (props) => {
  return <img src="/images/o7ean-logo.png" {...props} />;
};
